export const caseStudyRowCss = "w-[100vw] md:w-auto px-8 overflow-x-auto items-start mb-16"
